// TEMP PREVENT UPLOAD
export function initPreventUpload(elementSelector) {
    let container = document.querySelector(elementSelector);

    if (container != null) {
        let uploadButton = container.querySelector(".edit-profile__upload"),
            errorMessage = container.querySelector(".tempUploadErrorMessage");
        console.log(errorMessage);

        uploadButton.addEventListener("click", event => {
            event.preventDefault();
            errorMessage.innerHTML = `<p>Bemærk at det af tekniske årsager desværre ikke er muligt at tilføje eller ændre profilbilledet i øjeblikket. Send i stedet billedet til <a href="mailto:">kommunikation@lejerbo.dk</a></p>`;
        });
    }
}